import React from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import AntdProForm from '@ant-design/pro-form';
import { ProFormDependency } from '@ant-design/pro-form';
import { ProForm } from 'components/layout';
import {
  SelectTeamMemberType,
  SelectFaculty,
  SelectDepartment,
  SelectUser,
} from 'components/input';
// import { clearDepartmentOnFacultyChange } from 'components/input/SelectFaculty';

const TeamForm = ({ onFinish, initialValues }) => {
  const { projectId } = useParams();
  const [form] = AntdProForm.useForm();

  return (
    <ProForm
      form={form}
      initialValues={initialValues}
      previousLevel={`/projects/${projectId}/team`}
      onFinish={onFinish}
    >
      <SelectTeamMemberType />
      <SelectFaculty rules={[]} />
      <SelectDepartment rules={[]} form={form} />
      {/* <SelectUser form={form} /> */}
      <ProFormDependency name={['department', 'faculty']}>
        {({ department, faculty }) => (
          <SelectUser
            name="user"
            label="User"
            initialValues={initialValues}
            department={department}
            faculty={faculty}
          />
        )}
      </ProFormDependency>
    </ProForm>
  );
};

TeamForm.defaultProps = {
  initialValues: {},
};

TeamForm.propTypes = {
  onFinish: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired,
};

export default TeamForm;
